<div class="edit-page-root-container area-manager-component-container">
    <div class="page-content">
        <!-- Page Header -->
        <div class="page-header">
            <div class="page-title">
                <img class="icon" src="assets/images/menu/svg/area-manager.svg" width="30" height="30">
                <span class="title">Area Manager Shop</span>
            </div>

            <!-- Action Buttons -->
            <div class="action-btn-container">
                <!-- <button mat-flat-button class="action-btn btn-discard" 
                        [disabled]="isLoading"
                        (click)="exportClicked()">
                    EXPORT
                </button> -->
                <button mat-flat-button class="action-btn btn-discard" [disabled]="isSaving" (click)="resetToDefault()">
                    DISCARD
                </button>
                <button mat-flat-button class="action-btn btn-save" [disabled]="isLoading || !selectedAreaManagerId"
                    (click)="saveChanges()">
                    SAVE
                </button>
            </div>
        </div>

        <!-- Page Details -->
        <div class="page-details">
            <div class="detail-section">
                <div class="content-container">
                    <!-- Loading Overlay -->
                    <!-- <div class="loading-overlay" *ngIf="isLoading">
                        <div class="loader-container">
                            <app-loader [show]="true"></app-loader>
                        </div>
                    </div> -->

                    <!-- Area Manager Selection and Shop Search -->
                    <div class="selection-row">
                        <div class="dropdown-container">
                            <mat-form-field appearance="fill">
                                <mat-label>Select Area Manager</mat-label>
                                <input type="text" placeholder="Select Area Manager" aria-label="Area Manager" matInput
                                    [formControl]="areaManagerControl" [matAutocomplete]="auto" [disabled]="isLoading">

                                <!-- Clear button -->
                                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearAreaManager()"
                                    *ngIf="areaManagerControl.value && !isLoading">
                                    <mat-icon>close</mat-icon>
                                </button>

                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayManagerName"
                                    (optionSelected)="onAreaManagerSelected($event)">
                                    <mat-option *ngFor="let manager of filteredManagers | async" [value]="manager">
                                        {{ manager.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                        <div class="search-container">
                            <mat-form-field appearance="fill">
                                <mat-label>Search Shop Name</mat-label>
                                <input matInput [formControl]="shopSearchControl"
                                    placeholder="Type shop name to filter..."
                                    [disabled]="isLoading || !selectedAreaManagerId">
                                <mat-icon matSuffix>search</mat-icon>
                                <button mat-icon-button matSuffix (click)="shopSearchControl.setValue('')"
                                    *ngIf="shopSearchControl.value">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Shop Assignment Table -->
                    <div class="table-container">
                        <app-loader [show]="isLoading"></app-loader>

                        <table class="menu-table" *ngIf="dataSource.filteredData.length > 0 && !isLoading">
                            <!-- Table Header -->
                            <thead>
                                <tr>
                                    <th class="si-column">SI</th>
                                    <th class="function-column">Shop Name</th>
                                    <th class="role-column">
                                        Assign Shop
                                    </th>
                                    <th class="role-column">
                                        Allow Login
                                    </th>
                                </tr>
                            </thead>

                            <!-- Table Body -->
                            <tbody>
                                <!-- Shop Items -->
                                <tr class="menu-item-row" *ngFor="let shop of dataSource.filteredData; let i = index">
                                    <td class="si-cell">{{ i + 1 }}</td>
                                    <td class="function-cell" [title]="shop.name">{{ shop.name }}</td>
                                    <td class="role-cell">
                                        <mat-checkbox [checked]="!!shop.assign_shop"
                                            (change)="onAssignShopChange(shop, $event.checked)"
                                            [disabled]="!selectedAreaManagerId || isLoading">
                                        </mat-checkbox>
                                    </td>
                                    <td class="role-cell">
                                        <mat-checkbox [checked]="!!shop.allow_login"
                                            (change)="onAllowLoginChange(shop, $event.checked)"
                                            [disabled]="!selectedAreaManagerId || !shop.assign_shop || isLoading">
                                        </mat-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- No Data Message -->
                        <div *ngIf="dataSource.filteredData.length === 0 && !isLoading" class="no-data">
                            <mat-icon style="font-size: 48px; color: #ccc;">info</mat-icon>
                            <p *ngIf="selectedAreaManagerId && areaManagerShopList.length > 0">No matches found for
                                "{{shopSearchControl.value}}".</p>
                            <p *ngIf="selectedAreaManagerId && areaManagerShopList.length === 0">No shops found for the
                                selected Area Manager.</p>
                            <p *ngIf="!selectedAreaManagerId">Please select an Area Manager to assign shops.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>